import { html, unsafeCSS } from 'lit';
import { ScopedRegistryHost } from '@lit-labs/scoped-registry-mixin';
import { LeafElement } from '@cigna/dcws_leaf-web-components/components/leaf-element.js';
import { LeafButton } from '@cigna/dcws_leaf-web-components/components/button/button.component.js';
import { LeafIcon } from '@cigna/dcws_leaf-web-components/components/icon/icon.js';
import { LeafList } from '@cigna/dcws_leaf-web-components/components/list/list.component.js';
import { CHCHeadingList } from '@cigna/dcws_leaf-web-components/chc-components/heading-list/heading-list.js';
import { property } from 'lit/decorators.js';
import { CHCUnderstandingMedicareCard } from './understanding-medicare-card.js';
import styles from './understanding-medicare-chart.scss?inline';

export class CHCUnderstandingMedicareChart extends ScopedRegistryHost(LeafElement) {
  static override styles = unsafeCSS(styles);
  static elementDefinitions = {
    'leaf-button': LeafButton,
    'chcapp-understanding-medicare-card': CHCUnderstandingMedicareCard,
    'leaf-icon': LeafIcon,
    'leaf-list': LeafList,
    'chc-heading-list': CHCHeadingList,
  };

  @property({ reflect: true })
  variant: '2-col' | '1-col' = '1-col';

  override render() {
    if (this.variant === '2-col') {
      return html`
        <div slot="heading-list">
          <slot name="heading-list-header"></slot>
          <slot name="heading-list-desc"></slot>
        </div>
        <div class="leaf-container-full-width">
          <div class="leaf-grid-container">
            <div class="row iw_row">
              <div class="columns iw_columns large-1"></div>
              <div class="columns iw_columns large-10">
                <div class="tcg-c-row tcg-c-row--columns-2">
                  <div>
                    <slot name="original-medicare-card"></slot>
                  </div>
                  <div class="or"><slot name="or"></slot></div>
                  <div>
                    <slot name="part-c-card"></slot>
                  </div>
                </div>
              </div>
              <div class="columns iw_columns large-1"></div>
            </div>
          </div>
        </div>
      `;
    } else {
      return html`
        <slot name="heading-list-header"></slot>
        <slot name="heading-list-desc"></slot>
        <div class="static">
          <div class="row iw_row">
            <div class="columns iw_columns large-1"></div>
            <div class="columns iw_columns large-9">
              <slot name="card"></slot>
            </div>
            <div class="columns iw_columns large-2"></div>
          </div>
        </div>
      `;
    }
  }
}
